// import { Component, Prop, Vue } from 'vue-property-decorator';
// import Loader from '@/components/Loader/index.vue';

// import { validationMixin } from 'vuelidate'
// import { required, email } from 'vuelidate/lib/validators';
// import { Validations } from 'vuelidate-property-decorators';

import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
// import searchHelper from '@/helpers/search'
// import Search from '@/components/Search/index.vue'
// import RowEdit from '@/components/edit/RowEdit/index.vue'
// import MessageError from '@/components/edit/MessageError/index.vue'
// import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
// import MessageErrorAlert from '@/components/edit/MessageErrorAlert/index.vue'
import SelectPortal from '@/components/edit/SelectPortal/index.vue'

import { validationMixin } from 'vuelidate'
import { required, email, minLength, between } from 'vuelidate/lib/validators'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import { Validations } from 'vuelidate-property-decorators'

// import { cloneDeep } from 'lodash'
// import utils from '@/helpers/utils'

library.add(faTrashAlt)

@Component({
	components: {
		Loader,
		SelectPortal,
	},
	mixins: [validationMixin],
})
export default class TableGroups extends Vue {
	result = null
	saving = false

	data() {
		return {
			email: '',
			verify: '',
		}
	}

	get invalid() {
		return this.$v.email.$invalid || this.$v.verify.$invalid
	}

	get submittable() {
		return !this.invalid && !this.saving
	}

	mustBeCool = (value) => value === 'tenho certeza'

	@Validations()
	validations() {
		return {
			email: {
				required,
				email,
			},
			verify: {
				required,
				mustBeCool: this.mustBeCool,
			},
		}
	}

	async submit(e) {
		e.preventDefault()

		if (this.submittable) {
			this.saving = true

			const data = await this.$store.dispatch('startChallenge', {
				email: this.$v.email.$model,
			})

			this.saving = false
			this.result = data
		}
	}
}
